import { theme } from "../../theme";

export const alertOverview = {
    wrapper: {
        height: "calc(100vh - 105px)",
        display: "flex",
        flexDirection: "column",
    },
    alertRoot: {
        width: '45%',
        position: "relative",
        textAlign: "center",
        height: "100%",
    },
    topActions: {
        display: "flex",
        alignItems: "center",
        justifyContent:'space-between',
    },
    topFilters: {
        paddingTop: "20px",
        paddingBottom: "20px",
    },
    userIcon: {},
    searchForm: {
        padding: "0px 10px",
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        boxShadow: "0px 4px 8px rgb(0 0 0 / 5%)",
        border: "1px solid #E7E7E7",
        borderRadius: "6px",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderRight: 0,
    },
    searchInput: {
        flex: 1,
        border: 0,
        boxShadow: "none",
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        "&.MuiFormControl-root": {
            m: 0,
        },
        "& .MuiInputBase-root": {
            padding: "9px 10px 9px 10px",
            borderTopRightRadius: "0 !important",
            borderBottomRightRadius: "0 !important",
        },
    },
    clearIcon: {
        cursor: "pointer",
    },
    searchButton: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: "5px",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: "5px",
    },
    listContent: {
        position: "relative",
        width: "100%",
        flexGrow: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        overflow: "auto",
        mt:4,
    },
} as const;

export const alertForm = {
    root: {
        width: "45%",
        height: "100%",
        backgroundColor: theme.palette.grey[600],
        overflow: "auto",
        borderRadius: "5px",
    },
    infoTitle: {
        backgroundColor: "#fff",
        display: "flex",
        padding: "20px",
    },
    infoFields: {
        padding: "20px",
        textAlign: "left",
    },
    avatar: {
        width: "50px",
        height: "50px",
        marginRight: "20px",
    },
    selectField: {
        marginBottom: "15px",
    },
    userImage: {
        width: "5vw",
        height: "5vw",
        maxWidth: "100px",
        maxHeight: "100px",
        position: "relative",
        marginRight: "25px",
    },
    saveButton: {
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        height: "60px",
        zIndex: 11,
        fontSize: "18px",
        borderRadius: "0",
        width: "100%",
        fontWeight: "500",
    },
    checkbox: {
        color: theme.palette.grey["800"],
    },
    highlightContainer: {
        border: `5px solid ${theme.palette.primary.main}`,
    },
    formRoot: {
        "& .MuiFormControl-root": {
            m: 0,
        },
        "& .MuiFormHelperText-root ": {
            mx: 0,
        },
    },
    editPasswordButton: {
        mt: 2,
        p: 0,
        minWidth: "20px",
        ml: 1,
    }
} as const;
